import { useEffect, useMemo, useState } from "react";
import client from "../api/client";

const companyId = () => Number(localStorage.getItem("companyId") || 0);
const val = (r, ...keys) =>
  keys.map((k) => r?.[k]).find((x) => x !== undefined && x !== null) ?? "";
const safe = (v) =>
  v === null || v === undefined ? "" : typeof v === "object" ? "" : String(v);
const money = (v) =>
  Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
const err = (e, fb) =>
  e?.response?.data?.message ||
  e?.response?.data?.title ||
  (typeof e?.response?.data === "string" ? e.response.data : fb);

export default function InventoryReportPage({
  title,
  subtitle,
  endpoint,
  columns,
  amountColumns = [],
}) {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const res = await client.get(endpoint, {
        params: { companyId: companyId() || undefined },
      });
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      alert(err(e, "Failed to load report"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [endpoint]);

  const filtered = useMemo(() => {
    const s = search.toLowerCase().trim();
    if (!s) return rows;
    return rows.filter((r) =>
      Object.values(r).map(safe).join(" ").toLowerCase().includes(s),
    );
  }, [rows, search]);

  return (
    <div className="container-fluid py-2" style={{ fontSize: 11, padding: 0 }}>
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
        }}
      >
        <div
          style={{
            background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
            color: "#fff",
            padding: "8px 12px",
          }}
        >
          <h6 style={{ fontSize: 13, fontWeight: 700, margin: 0 }}>
            <i className="bi bi-boxes me-2"></i>
            {title}
          </h6>
          <div style={{ fontSize: 10, opacity: 0.85 }}>{subtitle}</div>
        </div>
        <div style={{ padding: 10 }}>
          <div className="row g-2 mb-2">
            <div className="col-md-4">
              <input
                className="form-control form-control-sm"
                style={{ height: 30, fontSize: 11 }}
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <button
                className="btn btn-primary btn-sm w-100"
                style={{ height: 30, fontSize: 11 }}
                onClick={load}
              >
                {loading ? "Loading..." : "Refresh"}
              </button>
            </div>
            <div className="col-md-6 d-flex justify-content-end align-items-center">
              <span className="text-muted">
                Rows: <strong>{filtered.length}</strong>
              </span>
            </div>
          </div>
          <div
            style={{
              maxHeight: 470,
              overflow: "auto",
              border: "1px solid #e9ecef",
              borderRadius: 10,
            }}
          >
            <table
              className="table table-bordered table-hover align-middle"
              style={{ fontSize: 11, minWidth: 1100, marginBottom: 0 }}
            >
              <thead>
                <tr>
                  {columns.map((c) => (
                    <th
                      key={c.key}
                      style={{
                        fontSize: 10,
                        color: "#fff",
                        background: "#07111f",
                        padding: "7px 8px",
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: 0,
                      }}
                      className={
                        amountColumns.includes(c.key) ? "text-end" : ""
                      }
                    >
                      {c.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="text-center text-muted"
                      style={{ padding: 18 }}
                    >
                      {loading ? "Loading..." : "No records found"}
                    </td>
                  </tr>
                ) : (
                  filtered.map((r, i) => (
                    <tr key={i}>
                      {columns.map((c) => {
                        const value = val(
                          r,
                          c.key,
                          c.key.charAt(0).toLowerCase() + c.key.slice(1),
                        );
                        return (
                          <td
                            key={c.key}
                            className={
                              amountColumns.includes(c.key) ? "text-end" : ""
                            }
                          >
                            {amountColumns.includes(c.key)
                              ? money(value)
                              : safe(value) || "-"}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
